import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

export default function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div data-testid="not-found-page" className="ops-panel p-8">
      <h1 className="text-2xl font-semibold tracking-tight">{t.notFound.title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t.notFound.body}</p>
      <Link
        to="/"
        data-testid="not-found-back-link"
        className="ops-focus mt-5 inline-flex rounded-sm bg-primary px-3 py-1.5 text-sm font-semibold text-primary-foreground transition-colors duration-150 hover:bg-primary/90"
      >
        {t.notFound.back}
      </Link>
    </div>
  );
}
